<template>
  <div class="container">
    <div class="login">
      <!-- ADD LOGO HERE -->
    </div>
    <div class="row justify-content-center">
      <div class="col-sm-12 col-md-10 col-lg-6">
        <div class="card-group mb-0">
          <div class="card p-4">
            <div class="card-body">
              <h1>Arautos</h1>
              <p class="text-muted">Entre com seu usuário e senha</p>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="fa fa-user"></i>
                  </span>
                </div>
                <input
                  @keyup.enter="onClickListenerLogin()"
                  @change="message=''"
                  v-model="user.username"
                  type="text"
                  class="form-control"
                  autocomplete="off"
                  placeholder="Usuário / CPF"
                >
              </div>
              <div class="input-group mb-4">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="fa fa-lock"></i>
                  </span>
                </div>
                <input
                  @keyup.enter="onClickListenerLogin()"
                  @change="message=''"
                  v-model="user.password"
                  type="password"
                  class="form-control"
                  autocomplete="off"
                  placeholder="Senha"
                >
              </div>

              <button @click="onClickListenerLogin()" type="button" class="btn btn-secondary" :disabled="loading">Entrar <i class="fa" :class="{'fa-sign-in': !loading, 'fa-spin fa-spinner': loading}"></i></button>
            </div>
          </div>
        </div>

        <hr>
        <div class="col-md-12">
          <div class="alert alert-danger text-center" v-show="message">{{ message }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { userService } from "../service/";
import { utilsService } from "../service/";

export default {
  name: "Login",

  data: function() {
    return {
      loading: false,

      message: "",
      user: {
        username: "",
        password: ""
      }
    };
  },


  mounted() {
    if (this.$store.state.user.token) {
      let user = this.$store.state.user;
      this.$router.push(
        user.level.toLowerCase() === "consultor" ? "sale" : "main"
      );
    }
  },

  methods: {
    onClickListenerLogin: function() {
      this.loading = true
      this.message = "";
      userService
        .doLogin(this.user.username, this.user.password)
        .then(user => {
          this.loading = false
          utilsService
            .getPabx(user.pabx)
            .then(pabx => {
              this.$store.commit("setPabx", pabx);
              this.$router.push(
                user.level.toLowerCase() === "consultor" ? "sale" : "main"
              );
            })
            .catch(_ => {
              this.loading = false
              this.$router.push(
                user.level.toLowerCase() === "consultor" ? "sale" : "main"
              );
            });
        })
        .catch(err => {
          this.loading = false
          console.log("ERRO Login", err);
          this.message = err;
        });
    },

    reload() {
      // if (this.hasUpdate) {
      //   window.location.reload();
      // }
    }
  }
};
</script>
<style scoped>
#update-app {
  position: absolute;
  bottom: 20;
  right: 20;
}
</style>





// WEBPACK FOOTER //
// Login.vue?93725c58